import { Scale } from 'lucide-react'

const phoneDisplay = '214-754-5500'
const phoneHref = 'tel:+12147545500'

const pageLinks = [
  { href: '/commercial-litigation', label: 'Commercial Litigation' },
  { href: '/personal-injury-litigation', label: 'Personal Injury Litigation' },
  { href: '/real-estate', label: 'Real Estate' },
  { href: '/attorney', label: 'Robert W. Buchholz' },
]

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container footer-main">
        <div className="footer-brand">
          <div className="brand-mark" aria-hidden="true">
            <Scale size={25} strokeWidth={1.7} />
          </div>
          <div>
            <strong>The Law Office of Robert W. Buchholz, P.C.</strong>
            <p>Commercial Litigation · Personal Injury Litigation · Real Estate</p>
          </div>
        </div>
        <nav className="footer-page-links" aria-label="Site pages">
          {pageLinks.map(({ href, label }) => (
            <a href={href} key={href}>{label}</a>
          ))}
        </nav>
        <div className="footer-contact">
          <a href={phoneHref}>{phoneDisplay}</a>
          <span>5220 Spring Valley Rd, Suite 618, Dallas, TX 75254</span>
        </div>
      </div>
      <div className="container footer-legal">
        <p>
          This website is for general informational purposes only and does not
          constitute legal advice. Viewing this site or contacting the firm does not
          create an attorney-client relationship.
        </p>
        <div className="footer-legal-links">
          <a href="/privacy">Privacy Policy</a>
          <p>© {new Date().getFullYear()} The Law Office of Robert W. Buchholz, P.C.</p>
        </div>
      </div>
    </footer>
  )
}

export default SiteFooter
